import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import {
  getMfinExciseStampRequestFilterItems,
  getMfinExciseStampRequestTableColumns,
  MFIN_EXCISE_STAMP_INITIAL_FILTERS,
} from "../../../../modules/ministry/ministry.constants";
import { MinistryContext } from "../../../../modules/ministry/ministry.context";
import { useMfinExciseStampRequestList } from "../../../../modules/ministry/ministry.queries";
import {
  MfinExciseStampRequest,
  MfinExciseStampRequestListPayload,
  MfinExciseStampRequestListResponse,
} from "../../../../modules/ministry/ministry.types";

export const MinistryStampsList = () => {
  const navigate = useNavigate();
  const { setMinistry } = useContext(MinistryContext);

  const onTableRowClickHandler = (record: MfinExciseStampRequest) => {
    setMinistry({
      selectedMarkicaId: record.id,
      evidencioniBroj: record.brojZahteva,
    });
    navigate(`/mfin/listaMarkica/detaljiMarkica?id=${record.id}`);
  };

  return (
    <FilterableTableLayout<
      MfinExciseStampRequest,
      MfinExciseStampRequestListResponse,
      MfinExciseStampRequestListPayload
    >
      tableRowKey="id"
      dataListKey="exciseStampRequestList"
      getTableColumns={getMfinExciseStampRequestTableColumns}
      onTableRowClick={onTableRowClickHandler}
      queryHook={useMfinExciseStampRequestList}
      tableName="mfin_excise_stamp_request_table"
      title={t("AKCIZNE_MARKICE.LISTA_ZAHTEVA_ZA_AKCIZNE_MARKICE")}
      toolbarId="mfin_excise_stamp_request_list"
      filterProps={{
        getFilterItems: getMfinExciseStampRequestFilterItems,
        initialFilters: MFIN_EXCISE_STAMP_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.MFIN_EXCISE_STAMP_REQUEST_LIST,
        triggerQueryManually: true,
      }}
    />
  );
};
